































import {defineComponent, reactive, nextTick} from '@vue/composition-api'

export default defineComponent({
  name: 'TimelineControlMenu',
  setup(props, {emit}) {
    const state: {open: boolean; x: number; y: number; target: EventTarget | null; elementType: string} = reactive({
      open: false, x: 0, y: 0, target: null, elementType: '',
    })

    const open = ($event: MouseEvent, elementType = '') => {
      $event.preventDefault()
      state.open = false
      state.x = $event.clientX
      state.y = $event.clientY
      state.target = $event.target
      state.elementType= elementType
      nextTick(() => state.open = true)
    }

    const close = () => {
      if (state.open)
        nextTick(() => state.open = false)
    }
    const addPose = () => {
      if (state.open)
        emit('addPose', {target: state.target, x: state.x})
    }

    const removePose = () => {
      if (state.open)
        emit('removePose', {target: state.target, x: state.x})
    }

    return {state, open, close, addPose, removePose,}
  },
})
